import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import Bar from './Bar';
const FiscalYearFrame = ({ index, firstBarY, label, secondBarY, thirdBarY, selectedIndex, firstBarColor, thirdBarColor, secondBarColor, setSelectedIndex, maxHeightPositive, maxHeightNegative, }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      <View style={styles.graphContainer}>
        {firstBarY !== undefined && (<Bar color={firstBarColor} height={rem(firstBarY)} positiveYMaxHeight={maxHeightPositive} negativeYMaxHeight={maxHeightNegative}/>)}
        {secondBarY !== undefined && (<>
            <Spacer w={1.5}/>
            <Bar height={rem(secondBarY)} color={secondBarColor} positiveYMaxHeight={maxHeightPositive} negativeYMaxHeight={maxHeightNegative}/>
          </>)}
        {!!(thirdBarY !== undefined && thirdBarColor) && (<>
            <Spacer w={1.5}/>
            <Bar color={thirdBarColor} height={rem(thirdBarY)} positiveYMaxHeight={maxHeightPositive} negativeYMaxHeight={maxHeightNegative}/>
          </>)}
      </View>
      <Spacer h={28}/>
      <TouchableBounce onPress={setSelectedIndex}>
        <View style={[styles.fiscalYearContainer, selectedIndex === index && styles.coloredBg]}>
          <Text Text-14 {...(selectedIndex === index ? { White: true } : {})}>
            {label}
          </Text>
        </View>
      </TouchableBounce>
      <Spacer h={18}/>
    </View>);
};
export default FiscalYearFrame;
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        alignItems: 'center',
    },
    graphContainer: {
        height: rem(150),
        flexDirection: 'row',
        justifyContent: 'center',
    },
    fiscalYearContainer: {
        borderRadius: rem(6),
        paddingVertical: rem(2),
        paddingHorizontal: rem(8),
    },
    coloredBg: {
        backgroundColor: colors.background.brand,
    },
}));
